module.exports = __webpack_public_path__ + "img/login.9af751cd.svg";